import { defineMessage } from 'react-intl';

export const i18nMessages = {
  clearAllFilters: defineMessage({
    id: 'component:filter.clear-all',
    defaultMessage: 'Clear all'
  }),
  clearFilters: defineMessage({
    id: 'component:filter.clear',
    defaultMessage: 'Clear'
  }),
  commentAsUser: defineMessage({
    id: 'component:label.comment-as-user',
    defaultMessage: 'Comment as <b>{name}</b>'
  }),
  dropUploadFiles: defineMessage({
    id: 'component:prompt.drop-files-upload',
    defaultMessage: 'Drop your files here'
  }),
  orDragAndDrop: defineMessage({
    id: 'component:prompt.or-drag-and-drop',
    defaultMessage: 'or drag and drop'
  }),
  showResults: defineMessage({
    id: 'component:filter.show-results',
    defaultMessage: 'Show results'
  }),
  writeComment: defineMessage({
    id: 'component:placeholder.write-comment',
    defaultMessage: 'What are your thoughts?'
  })
};
